import LayoutContent from '../../components/layouts/content2';
import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import CoctailScreen from './coctail.js';
import BeersScreen from './beers.js';
import MargaritasScreen from './margaritas.js';
import WinesScreen from './wines.js';
import SpiritsScreen from './spirits.js';
import BottlesScreen from './bottles.js';
import NoalcoholScreen from './noalcohol.js';

function Index({ setShowHappy }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { change } = useRefresh();

  const [menus, setMenus] = useState([]);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showCoctatik, setshowCoctatik] = useState(false);
  const [showBeers, setshowBeers] = useState(false);
  const [showBottles, setshowBottles] = useState(false);
  const [shownonAcohol, setshownonAcohol] = useState(false);
  const [showMargaritas, setshowMargaritas] = useState(false);
  const [showSpirits, setShowSpirits] = useState(false);
  const [showWines, setshowWines] = useState(false);
  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);
  const [beers, setbeers] = useState(false);
  const [coladas, setcoladas] = useState(false);
  const [martinis, setmartinis] = useState(false);
  const [sangria, setsangria] = useState(false);
  const [noalcol, setnoalcol] = useState(false);
  const [mojitos, setmojitos] = useState(false);
  const [margaritas, setmargaritas] = useState(false);
  const [dataCocktail, setdataCocktail] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 393) {
        setbeers(item);
      }
      if (item.id === 390) {
        setcoladas(item);
      }
      if (item.id === 391) {
        setmartinis(item);
      }
      if (item.id === 392) {
        setsangria(item);
      }
      if (item.id === 417) {
        setnoalcol(item);
      }
      if (item.id === 614) {
        setmojitos(item);
      }
      if (item.id === 615) {
        setmargaritas(item);
      }
      if (item.id === 590) {
        setdataCocktail(item);
      }
    });
  }, [menus]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
      }}
    >
      <LayoutContent
        showBack={true}
        setShowSpecials={setShowSpecials}
        setShowListProduct={setShowHappy}
      >
        <div style={{ padding: '0 20px' }}>
          <h1
            style={{
              color: 'white',
              textTransform: 'uppercase',
              fontSize: 40,
              fontWeight: '900',
            }}
          >
            drinks / bebidas
          </h1>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              paddingInline: 30,
            }}
          >
            <div
              onClick={() => {
                setshowCoctatik(true);
              }}
              className="shadow"
              style={{
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',

                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
                marginInline: 10,
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  COCKTAILS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(dataCocktail);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
                marginInline: 10,
                position: 'relative',
              }}
            >
              <div
                style={{
                  backgroundColor: '#D60000',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 40,
                  height: 40,
                  borderRadius: 100,
                  position: 'absolute',
                  top: -15,
                  right: -15,
                  boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)',
                }}
              >
                <p style={{ color: 'white', fontSize: 14, fontWeight: 'bold' }}>
                  NEW
                </p>
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  MOCKTAILS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setshowBeers(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                width: 270,
                height: 70,
                marginTop: 20,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  BEERS
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(margaritas);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  MARGARITAS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setdishs(mojitos);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  MOJITOS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setshowWines(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  WINES
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(coladas);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  COLADAS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setShowSpirits(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  SPIRITS
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(martinis);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  MARTINIS
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setshowBottles(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  BOTTLE SERVICES
                </p>
              </div>
            </div>

            <div
              onClick={() => {
                setdishs(sangria);
                setShowListProduct(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  SANGRIA
                </p>
              </div>
            </div>
            <div
              onClick={() => {
                setshownonAcohol(true);
              }}
              className="shadow"
              style={{
                marginInline: 10,
                marginTop: 20,
                width: 270,
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 5,
                display: 'flex',
                backgroundColor: '#fff',
                border: '3px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#ED3E08',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  NON ALCOHOLIC
                </p>
              </div>
            </div>
          </div>
        </div>

        {showListProduct && (
          <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
        )}

        {showCoctatik && <CoctailScreen setShowHappy={setshowCoctatik} />}
        {showBeers && <BeersScreen setShowHappy={setshowBeers} />}
        {showMargaritas && (
          <MargaritasScreen setShowHappy={setshowMargaritas} />
        )}
        {showWines && <WinesScreen setShowHappy={setshowWines} />}
        {showSpirits && <SpiritsScreen setShowHappy={setShowSpirits} />}
        {showBottles && <BottlesScreen setShowHappy={setshowBottles} />}
        {shownonAcohol && <NoalcoholScreen setShowHappy={setshownonAcohol} />}

        {showSpecials && (
          <SpecialsScreen
            setShowListProduct={setShowSpecials}
            setShowHappy={setShowHappy}
          />
        )}
      </LayoutContent>
    </div>
  );
}
export default Index;
